{
    "Bbk": {
        "storeLocatorPoint": {
            "pageTitle": "Shop adresses",
            "city": "city",
            "showOnMap": "show on map",
            "showMore": "show more",
            "showLess": "show less",
            "loadMore": "load more",
            "hidePoints": "hide points",
            "moFr": "Mon - Fri",
            "sa": "Sat",
            "sn": "Sun",
            "cityInputValidationMessage": "city is required"
        }
    }
}
